import script from "./NotificationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationPage.vue?vue&type=style&index=0&id=55263c34&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55263c34"]])

export default __exports__